export namespace ReorderRuleTranslations {
  export const error = {
    reorderRuleExportConfigurationsUnableToLoadError: 'reorderRuleExportConfigurationsUnableToLoadError',
  } as const;
}
